import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let StripLinesDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-striplines';
        }
    }
});
export const StripLinesPlugin = {
    name: 'e-striplines',
    install(Vue) {
        Vue.component(StripLinesPlugin.name, StripLinesDirective);
    }
};
export let StripLineDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-stripline';
        }
    }
});
export const StripLinePlugin = {
    name: 'e-stripline',
    install(Vue) {
        Vue.component(StripLinePlugin.name, StripLineDirective);
    }
};
